import { fetchDraft } from './fetchDraft';

declare global {
	interface Window {
		__PRELOAD_DRAFT__?: any;
	}
}

export async function preloadDraft(contentId: string, draftShareId?: string) {
	window.__PRELOAD_DRAFT__ = {
		contentId,
		draftFetchPromise: fetchDraft(contentId, draftShareId),

		startTime: window?.performance?.now?.(),
	};
}

const DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';

export function isDraftSSRPreloadPermissionError(message?: string) {
	if (!message) return false;
	return message.indexOf(DRAFT_PERMISSION_ERROR) > -1 || false;
}
